@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';

.fancy-state-icon {
  position: relative;
  height: 100%;
  width: 100%;

  &:before {
    content: '';
    position: absolute;
    background: @fancy-state-icon--before--background-color;
    z-index: 2;
  }

  > svg {
    transform: scale(0.5);
    position: relative;
    z-index: 5;
  }
}

.error-icon {
  background: @fancy-state-icon--error--background-color;
  border-radius: 50%;

  &:before {
    inset: 20% 40%;
  }

  > svg {
    color: @fancy-state-icon--error--fill-color;
    width: 148%;
    height: 148%;
    top: -24%;
    left: -24%;
  }
}

.warning-icon {
  position: relative;
  height: 100%;
  width: 100%;

  &:before {
    inset: 30% 44% 24%;
  }

  > svg {
    width: 120%;
    height: 120%;
    top: -10%;
    left: -10%;
    color: @fancy-state-icon--warning--fill-color;
  }
}

.info-icon {
  background: @fancy-state-icon--info--background-color;
  border-radius: 50%;

  &:before {
    inset: 20% 40%;
  }

  > svg {
    color: @fancy-state-icon--info--fill-color;
    width: 148%;
    height: 148%;
    top: -24%;
    left: -24%;
  }
}

.triangle {
  .vertical-align();
  position: absolute;
  left: 0;
  right: 0;
  margin-top: -32%;
  margin-right: auto;
  margin-left: auto;
  background-color: @fancy-state-icon--warning--background-color;
  width: 54%;
  height: 54%;
  transform: rotate(-60deg) skewX(-30deg) scale(1, 0.866);
  border-top-right-radius: 30%;

  &:before,
  &:after {
    content: '';
    position: absolute;
    background-color: inherit;
    width: 100%;
    height: 100%;
    border-top-right-radius: 30%;
  }

  &:before {
    transform: rotate(-135deg) skewX(-45deg) scale(1.414, 0.707) translate(0, -50%);
  }

  &:after {
    transform: rotate(135deg) skewY(-45deg) scale(0.707, 1.414) translate(50%);
  }
}
